module.exports = __webpack_public_path__ + "img/logo-mobile-light.150b94f1.svg";